<template>
  <ManageSuppliers update />
</template>
<script>
import appConfig from '@/app.config'
import ManageSuppliers from '@/components/skillup/suppliers/ManageSuppliers.vue'
export default {
  page: {
    title: 'مدیریت تامین کنندگان',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-edit-suppliers',
  components: {
    ManageSuppliers,
  },
}
</script>
